import { request, RespError, handleFormatRes, tryDecode } from '../../utils';
import { QRY_COUPON_DETAIL } from '../../config/url';
/** 券使用状态 */
export var CouponDetailTransState;
(function (CouponDetailTransState) {
    /** 待使用 */
    CouponDetailTransState[CouponDetailTransState["UNUSED"] = 1] = "UNUSED";
    /** 已使用  */
    CouponDetailTransState[CouponDetailTransState["USED"] = 2] = "USED";
    /** 已过期 */
    CouponDetailTransState[CouponDetailTransState["EXPIRED"] = 3] = "EXPIRED";
    /** 已退款 */
    CouponDetailTransState[CouponDetailTransState["REFUNDED"] = 4] = "REFUNDED";
    /** 预使用 */
    CouponDetailTransState[CouponDetailTransState["PREUSED"] = 5] = "PREUSED";
})(CouponDetailTransState || (CouponDetailTransState = {}));
/** 优惠券类型 */
export var CouponDetailType;
(function (CouponDetailType) {
    /** 金额券 */
    CouponDetailType[CouponDetailType["AMOUNT_COUPON"] = 1] = "AMOUNT_COUPON";
    /** 折扣券 */
    CouponDetailType[CouponDetailType["DISCOUNT_COUPON"] = 2] = "DISCOUNT_COUPON";
})(CouponDetailType || (CouponDetailType = {}));
/** 分享类型 */
export var ShareType;
(function (ShareType) {
    /** 不可分享、不可裂变 */
    ShareType[ShareType["NOT_SHAREABLE"] = 1] = "NOT_SHAREABLE";
    /** 可转赠 */
    ShareType[ShareType["CAN_BE_DONATED"] = 2] = "CAN_BE_DONATED";
    /** 可裂变 */
    ShareType[ShareType["FISSIONABLE"] = 3] = "FISSIONABLE";
})(ShareType || (ShareType = {}));
/**
 * 解析buttonUrl中的小程序信息
 */
function parseMiniAppInfo(buttonUrl) {
    let username = '';
    let path = '';
    if (buttonUrl && /^https:\/\/gh_/.test(buttonUrl)) {
        const splitArr = buttonUrl.substr(8).split(/[,|]/);
        username = splitArr[0];
        path = splitArr[1];
    }
    return {
        username,
        path,
    };
}
// 需要转成 int 型的 key 数组
const needParseIntKey = [
    'couponType',
    'transState',
    'useChannel',
    'shareType',
];
// 需要转成 int 型的 key 数组
const needParseDateKey = [
    'expireTime',
    'expireDay',
    'curTime',
];
// 需要转成以元为单位的key数组
const needFen2YuanKey = [
    'maxDiscount',
];
/**
 * 查询券详情
 *
 * 接口地址：`/app/promotion/prom_qry_usercoupon_detail.cgi`
 *
 */
export async function qryCouponDetail(userCouponId) {
    try {
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            user_coupon_id: userCouponId,
        };
        // 接口请求
        const result = await request.get(QRY_COUPON_DETAIL, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({
                    result,
                    needParseIntKey,
                    needParseDateKey,
                    needFen2YuanKey,
                    transformer: (res) => {
                        const couponData = res.couponList[0];
                        const { merLogoUrl, couponTandc, buttonUrl, couponRange, goodsUrl, brandName, discount, couponDesc, brandLogo, customizeJumpName, customizeJumpUrl, spidJumpUrl } = couponData;
                        const { username, path } = parseMiniAppInfo(tryDecode(buttonUrl));
                        return {
                            retcode: res.retcode,
                            retmsg: res.retmsg,
                            curTime: res.curTime,
                            couponDetail: Object.assign(Object.assign({}, couponData), { username,
                                path, couponLogo: tryDecode(merLogoUrl), tncUrl: tryDecode(couponTandc), discount, couponDesc: tryDecode(couponDesc), brandName: tryDecode(brandName), brandLogo: tryDecode(brandLogo), customizeJumpName: tryDecode(customizeJumpName), customizeJumpUrl: tryDecode(customizeJumpUrl), couponRange: tryDecode(couponRange), goodsUrl: tryDecode(goodsUrl), spidJumpUrl: tryDecode(spidJumpUrl), buttonUrl: tryDecode(buttonUrl) }),
                        };
                    },
                });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
